import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';



import { SampleComponent } from './sample.component';

const routes = [
    {
        path     : 'sample',
        component: SampleComponent
    }
];

@NgModule({
    imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    SampleComponent
],
    exports: [
        SampleComponent
    ]
})

export class SampleModule
{
}
